import { NgOptimizedImage } from '@angular/common';
import { HTTP_INTERCEPTORS, provideHttpClient, withFetch } from '@angular/common/http';
import { APP_INITIALIZER, ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule, provideClientHydration, withNoHttpTransferCache } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { SagtoastModule } from './core/shared/sagtoast/sagtoast.module';
import { SharedModule } from './core/shared/shared.module';
import { ThemesModule } from './core/themes/themes.module';
import { CustomHttpInterceptorService } from './services/http/interceptor';
import { CommonService } from './services/sagstudioService/common.service';
import { setupTranslateFactory } from './services/sagstudioService/translang';
import { TranslateService } from './services/sagstudioService/translate.service';
import { GlobalErrorHandler } from './core/errorHandler/ErrorHandler';


@NgModule({
  declarations: [
    AppComponent,
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    SharedModule,
    SagtoastModule,
    ThemesModule,
    NgOptimizedImage
  ],
  providers: [
    provideClientHydration( withNoHttpTransferCache()),
    provideHttpClient(withFetch()),
    TranslateService,
    CommonService,
    {
      provide: APP_INITIALIZER,
      useFactory: setupTranslateFactory,
      deps: [TranslateService],
      multi: true,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: CustomHttpInterceptorService,
      multi: true
    },
    {
      provide: ErrorHandler,
     useClass: GlobalErrorHandler
    }

  ],
  bootstrap: [AppComponent]
})
export class AppModule { }


